export default __webpack_public_path__ + "static/media/Attachement.64489821.svg";